import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDiamond: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"diamond, pro, premium"} maskId="square-filled-radius-0-stroke-1-IconDiamond"><path fillRule="evenodd" clipRule="evenodd" d="M7.29297 3H16.7072L23.7072 10L12.0001 21.7071L0.292969 10L7.29297 3ZM7.70718 8L5.70718 10L7.70718 12L7.00008 12.7071L4.29297 10L7.00008 7.29289L7.70718 8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDiamond;
